export default {"src":"/_next/static/media/img_user_hands_up.1af85530.svg","height":222,"width":64,"blurWidth":0,"blurHeight":0};